export * from './view';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/@uirouter/core/lib-esm/view/index.js
// module id = 166
// module chunks = 0